import { dataApi } from 'api/dataApi';
import { makeAutoObservable } from 'mobx';
import { ScoreItem, WeatherType } from 'mobx/commonTypes';
import { RootStore } from 'mobx/rootStore';

export namespace DataStore {
  export type Data = {
    transport_count: number;
    traffic_score: ScoreItem;
    traffic_speed: {
      direct_speed: number;
      reverse_speed: number;
    };
    large_accidents: number;
    roadwork_detail: number;
    traffic_score_forecast: ScoreItem[];
    weather: WeatherType;
  };

  export class Store {
    public rootStore: RootStore;
    public isPending = false;
    public isError = false;
    public data: Data | null = null;

    public get isInitialized() {
      return !!this.data;
    }

    constructor({ rootStore }: { rootStore: RootStore }) {
      this.rootStore = rootStore;
      makeAutoObservable(this);
    }

    public async fetch() {
      this.isError = false;
      this.isPending = true;

      try {
        this.data = await dataApi.getData();
        this.isPending = false;
      } catch (e) {
        console.error(e);
        this.isPending = false;
        this.isError = true;
      }
    }
  }
}
